module.exports = __webpack_public_path__ + "static/media/sort-numeric-down.9fd277b8.svg";